/******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ modules[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__,
    );
    /******/
    /******/ // Flag the module as loaded
    /******/ module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter,
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/ __webpack_require__.r = function (exports) {
    /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      /******/ Object.defineProperty(exports, Symbol.toStringTag, {
        value: "Module",
      });
      /******/
    }
    /******/ Object.defineProperty(exports, "__esModule", { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/ __webpack_require__.t = function (value, mode) {
    /******/ if (mode & 1) value = __webpack_require__(value);
    /******/ if (mode & 8) return value;
    /******/ if (
      mode & 4 &&
      typeof value === "object" &&
      value &&
      value.__esModule
    )
      return value;
    /******/ var ns = Object.create(null);
    /******/ __webpack_require__.r(ns);
    /******/ Object.defineProperty(ns, "default", {
      enumerable: true,
      value: value,
    });
    /******/ if (mode & 2 && typeof value != "string")
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key];
          }.bind(null, key),
        );
    /******/ return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module["default"];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, "a", getter);
    /******/ return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 0));
  /******/
})(
  /************************************************************************/
  /******/ [
    /* 0 */
    /***/ function (module, exports) {
      function _slicedToArray(arr, i) {
        return (
          _arrayWithHoles(arr) ||
          _iterableToArrayLimit(arr, i) ||
          _unsupportedIterableToArray(arr, i) ||
          _nonIterableRest()
        );
      }

      function _nonIterableRest() {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
        );
      }

      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (
          n === "Arguments" ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
        )
          return _arrayLikeToArray(o, minLen);
      }

      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }

      function _iterableToArrayLimit(arr, i) {
        if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
          return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (
            var _i = arr[Symbol.iterator](), _s;
            !(_n = (_s = _i.next()).done);
            _n = true
          ) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }

      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }

      var steps = 9;
      var currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      var currencyFormatterNoCents = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      var yes = "yes";
      var no = "no";
      var noPreference = "no-preference";
      var memoryFoamBudget1 = [
        [1250, 2199],
        [2200, 3699],
        [3700, Number.POSITIVE_INFINITY],
      ];
      var memoryFoamBudget2 = [
        [2000, 3499],
        [3500, 3999],
        [4000, Number.POSITIVE_INFINITY],
      ];
      var hybridBudget1 = [
        [269, 699],
        [700, 1499],
        [1500, Number.POSITIVE_INFINITY],
      ];
      var hybridBudget2 = [
        [449, 999],
        [1000, 2299],
        [2300, Number.POSITIVE_INFINITY],
      ];
      var traditionalBudget1 = [
        [199, 499],
        [500, 999],
        [1000, Number.POSITIVE_INFINITY],
      ];
      var traditionalBudget2 = [
        [249, 599],
        [600, 1199],
        [1200, Number.POSITIVE_INFINITY],
      ];
      var traditionalBudget3 = [
        [339, 799],
        [800, 1799],
        [1800, Number.POSITIVE_INFINITY],
      ]; // Default Budget (no selected mattress type)

      var defaultBudget = [
        [0, 799],
        [800, 1999],
        [2000, Number.POSITIVE_INFINITY],
      ];
      var currentBudget;
      var typeMemoryFoam = "memory";
      var typeHyrbid = "hybrid";
      var typeTraditional = "traditional";
      var sizeTwin = "twin";
      var sizeTwinXL = "twin-xl";
      var sizeFull = "full";
      var sizeQueen = "queen";
      var sizeKing = "king";
      var sizeSplitKing = "split-king";
      var sizeSplitCalKing = "split-cal-king";
      var sizeToBudget = new Map(); // Memory Foam

      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeTwin),
        memoryFoamBudget1,
      );
      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeTwinXL),
        memoryFoamBudget1,
      );
      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeFull),
        memoryFoamBudget1,
      );
      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeQueen),
        memoryFoamBudget1,
      );
      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeKing),
        memoryFoamBudget2,
      );
      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeSplitKing),
        memoryFoamBudget2,
      );
      sizeToBudget.set(
        "".concat(typeMemoryFoam, "|").concat(sizeSplitCalKing),
        memoryFoamBudget2,
      ); // Hyrbid

      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeTwin),
        hybridBudget1,
      );
      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeTwinXL),
        hybridBudget1,
      );
      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeFull),
        hybridBudget1,
      );
      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeQueen),
        hybridBudget1,
      );
      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeKing),
        hybridBudget2,
      );
      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeSplitKing),
        hybridBudget2,
      );
      sizeToBudget.set(
        "".concat(typeHyrbid, "|").concat(sizeSplitCalKing),
        hybridBudget2,
      ); // Traditional

      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeTwin),
        traditionalBudget1,
      );
      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeTwinXL),
        traditionalBudget1,
      );
      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeFull),
        traditionalBudget2,
      );
      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeQueen),
        traditionalBudget2,
      );
      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeKing),
        traditionalBudget3,
      );
      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeSplitKing),
        traditionalBudget3,
      );
      sizeToBudget.set(
        "".concat(typeTraditional, "|").concat(sizeSplitCalKing),
        traditionalBudget3,
      ); // Default budget if no mattress type selected

      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeTwin),
        defaultBudget,
      );
      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeTwinXL),
        defaultBudget,
      );
      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeFull),
        defaultBudget,
      );
      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeQueen),
        defaultBudget,
      );
      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeKing),
        defaultBudget,
      );
      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeSplitKing),
        defaultBudget,
      );
      sizeToBudget.set(
        "".concat(noPreference, "|").concat(sizeSplitCalKing),
        defaultBudget,
      );
      var brandSealy = "sealy";
      var brandTempurpedic = "tempurpedic";
      var brandStearnsFoster = "stearnsFoster";
      var brandMagniflex = "magniflex";
      var brandBedPlanet = "bedplanet";
      var brandBeautyRest = "beautyrest";
      var brandBedgear = "bedgear";
      var brandNoPreference = "no-preference";
      var products = [
        {
          name: "Sealy Spring Albany II Soft Pillowtop",
          handle:
            "sealy-posturepedic-elite-spring-albany-ii-14-soft-euro-pillowtop-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "soft", "TK"],
          type: "spring",
        },
        {
          name: "Sealy Hybrid Brenham II Firm",
          handle: "sealy-posturepedic-elite-hybrid-brenham-ii-16-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "hybrid",
        },
        {
          name: "Sealy Hybrid Brenham II Soft",
          handle: "sealy-posturepedic-elite-hybrid-brenham-ii-14-soft-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "hybrid",
        },
        {
          name: "Sealy Hybrid High Point II Firm",
          handle:
            "sealy-posturepedic-elite-hybrid-high-point-ii-14-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "hybrid",
        },
        {
          name: "Sealy Hybrid High Point II Soft",
          handle:
            "sealy-posturepedic-elite-hybrid-high-point-ii-14-soft-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "hybrid",
        },
        {
          name: "Tempur-Pedic ProAdapt® Firm",
          handle: "tempur-pedic-tempur-proadapt-firm-12-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Tempur-Pedic ProAdapt Medium",
          handle: "tempur-pedic-tempur-proadapt-medium-12-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "memory",
        },
        {
          name: "TEMPUR-ProAdapt Soft",
          handle: "tempur-pedic-tempur-proadapt-soft-12-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "memory",
        },
        {
          name: "Tempur-Pedic ProAdapt Medium Hybrid",
          handle: "tempur-pedic-tempur-proadapt-medium-hybrid-12-mattress",
          visible: true,
          hot: true,
          sleepType: ["TK", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "hybrid",
        },
        {
          name: "Tempur-Pedic LuxeAdapt Firm",
          handle: "tempur-pedic-luxeadapt-firm-13-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Tempur-Pedic LuxeAdapt Soft",
          handle: "tempur-pedic-luxeadapt-soft-13-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "memory",
        },
        {
          name: "Tempur-Pedic ProBreeze Medium",
          handle: "tempur-pedic-probreeze-medium-12-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Tempur-Pedic ProBreeze Medium Hybrid",
          handle: "tempur-pedic-probreeze-medium-hybrid-12-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "hybrid",
        },
        {
          name: "Tempur-Pedic LuxeBreeze Firm",
          handle: "tempur-pedic-luxebreeze-firm-13-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Tempur-Pedic LuxeBreeze Soft",
          handle: "tempur-pedic-luxebreeze-soft-13-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "memory",
        },
        {
          name: "Beautyrest Black Hybrid Series Four Firm Apex",
          handle: "beautyrest-black-hybrid-series-four-firm-apex-top-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "hybrid",
        },
        {
          name: "Beautyrest Black Series Three Extra Firm",
          handle: "beautyrest-black-series-three-14-25-extra-firm-mattress",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["ultraFirm", "TK", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black Hybrid Series Four Plush Apex",
          handle: "beautyrest-black-hybrid-series-four-plush-apex-top-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "hybrid",
        },
        {
          name: "Beautyrest Black® Series One Firm PillowTop",
          handle: "beautyrest-black®-series-one-14-25-plush-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black Series Three Plush PillowTop",
          handle:
            "beautyrest-black-series-three-16-5-medium-pillow-top-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black® Series Four Firm PillowTop",
          handle: "beautyrest-black-series-four-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black® Series One Extra Firm",
          handle: "beautyrest-black-series-one-13-5-extra-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["ultraFirm", "TK", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black Hybrid Series One Plush",
          handle: "beautyrest-black-hybrid-series-one-plush-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back", "stomach"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "hybrid",
        },
        {
          name: "Beautyrest Black Series Three Firm PillowTop",
          handle:
            "beautyrest-black-series-three-15-25-firm-pillow-top-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black Series Two Plush",
          handle: "beautyrest-black-series-two-15-5-plush-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "plush", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black® Series One Plush PillowTop",
          handle: "beautyrest-black®-series-one-14-medium-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black Series Three Firm",
          handle: "beautyrest-black-series-three-15-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest Black Series Two Plush PillowTop",
          handle: "beautyrest-black-series-two-16-25-plush-pillow-top-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "soft", "TK"],
          type: "traditional",
        },
        {
          name: "Beautyrest World Class Hybrid Level Four Plush",
          handle: "beautyrest-world-class-hybrid-level-four-plush-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "hybrid",
        },
        {
          name: "Beautyrest World Class Hybrid Level Four Firm",
          handle: "beautyrest-world-class-hybrid-level-four-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "hybrid",
        },
        {
          name: "Beautyrest World Class Hybrid Level Four Plush",
          handle: "beautyrest-world-class-hybrid-level-four-plush-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "soft", "TK"],
          type: "hybrid",
        },
        {
          name: "Beautyrest World Class Level Three Plush Pillow Top",
          handle:
            "beautyrest-world-class-level-three-plush-pillow-top-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Eighth & Park Ultra Firm Tight Top",
          handle:
            "crown-jewel-by-sealy-eighth-park-ultra-firm-tight-top-spring-14-5",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "TK", "ultraFirm", "TK"],
          type: "traditional",
        },
        {
          name: "Eighth & Park Soft Euro Pillow Top",
          handle:
            "crown-jewel-by-sealy-eighth-park-soft-euro-pillow-top-spring-15",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Sixth & Park Firm Tight Top",
          handle: "crown-jewel-by-sealy-sixth-park-firm-tight-top-spring-12-5",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "TK", "firm", "TK"],
          type: "traditional",
        },
        {
          name: "Second & Park Soft Tight Top",
          handle: "crown-jewel-by-sealy-second-park-soft-tight-top-spring-12",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Second & Park Firm Tight Top",
          handle:
            "crown-jewel-by-sealy-second-park-firm-tight-top-innerspring-10-5",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Fourth & Park Soft Tight Top",
          handle: "crown-jewel-by-sealy-fourth-park-soft-tight-top-spring-12",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Fourth & Park Euro Pillow Top Soft",
          handle:
            "crown-jewel-by-sealy-fourth-park-euro-pillow-top-soft-spring-14",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Fourth & Park Firm Tight Top",
          handle:
            "crown-jewel-by-sealy-fourth-park-firm-tight-top-innerspring-12",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Sealy Spring Paterson II Firm Pillowtop",
          handle:
            "sealy-posturepedic-plus-spring-paterson-ii-13-firm-euro-pillowtop-mattress",
          visible: true,
          hot: false,
          sleepType: ["back", "stomach"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Sealy Spring Paterson II Ultra Firm Tight Top",
          handle:
            "sealy-posturepedic-plus-spring-paterson-ii-14-ultra-firm-tight-top-mattress",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["ultraFirm", "TK", "TK", "TK"],
          type: "traditional",
        },
        {
          name: "Sealy Spring Paterson II Soft Tight Top",
          handle:
            "sealy-posturepedic-plus-spring-paterson-ii-15-soft-tight-top-mattress",
          visible: true,
          hot: false,
          sleepType: ["back", "stomach"],
          firmness: ["TK", "TK", "soft", "TK"],
          type: "traditional",
        },
        {
          name: "Sealy Spring Paterson II Firm Euro Pillowtop",
          handle:
            "sealy-posturepedic-plus-spring-paterson-ii-13-firm-euro-pillowtop-mattress",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "firm", "TK"],
          type: "traditional",
        },
        {
          name: "Sealy Spring Paterson II Soft Pillowtop",
          handle:
            "sealy-posturepedic-plus-spring-paterson-ii-14-soft-euro-pillow-top-mattress",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "traditional",
        },
        {
          name: "Bedplanet Gel Medium Firm Memory Foam",
          handle:
            "bedplanet-essentials-8-gel-infused-medium-firm-memory-foam-mattress",
          visible: true,
          hot: true,
          sleepType: ["back", "stomach"],
          firmness: ["TK", "TK", "medium", "firm", "TK"],
          type: "memory",
        },
        {
          name: "Bedplanet Lavender Gel Firm",
          handle: "bedplanet-lavender-12-gel-infused-firm-mattress",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Bedplanet Gel Plush Memory Foam",
          handle:
            "bedplanet-essentials-12-gel-infused-plush-memory-foam-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "soft", "TK"],
          type: "memory",
        },
        {
          name: "Bedplanet Copper Gel Medium Firm Memory Foam",
          handle:
            "bedplanet-12-copper-gel-infused-medium-firm-memory-foam-mattress",
          visible: true,
          hot: false,
          sleepType: ["side", "back", "stomach"],
          firmness: ["TK", "medium", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Bedplanet Copper Hybrid Plush Memory Foam",
          handle: "bedplanet-14-copper-hybrid-plush-memory-foam-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "memory",
        },
        {
          name: "Bedplanet iSwitch Flippable Medium Firm/Medium Soft",
          handle:
            "bedplanet-12-iswitch-flippable-two-sided-medium-firm-medium-soft-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back", "stomach"],
          firmness: ["soft", "firm", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Bedplanet Gel Medium Memory Foam",
          handle:
            "bedplanet-essentials-10-gel-infused-medium-memory-foam-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "TK", "medium"],
          type: "memory",
        },
        {
          name: "Magniflex Magnistretch 12",
          handle: "magniflex-magnistretch-12-mattress",
          visible: true,
          hot: false,
          sleepType: ["TK", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Magniflex MagniStretch Plus",
          handle: "magniflex-magnistretch-plus",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Magniflex Toscana Cotton Grande Dual 12",
          handle: "magniflex-toscana-cotton-grande-dual-12-mattress",
          visible: true,
          hot: false,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "soft"],
          type: "memory",
        },
        {
          name: "Magniflex Toscana Cotton Lux 10",
          handle: "magniflex-toscana-cotton-lux-10-mattress",
          visible: true,
          hot: false,
          sleepType: ["TK", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Magniflex Classico 9",
          handle: "magniflex-classico-9-special-order-sizes",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Magniflex Dolce Vita Dual 10",
          handle: "magniflex-dolce-vita-dual-10-mattress",
          visible: true,
          hot: false,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Magniflex Dolce Vita Dual 12",
          handle: "magniflex-dolce-vita-dual-12-special-order-sizes",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "soft"],
          type: "memory",
        },
        {
          name: "Magniflex Magnicool 10 Firm",
          handle: "magniflex-magnicool-10-firm-mattress-special-order-sizes",
          visible: true,
          hot: true,
          sleepType: ["stomach", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
        {
          name: "Magniflex Magnicool 12 Gel",
          handle: "magniflex-magnicool-12-gel-mattress-special-order-sizes",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "soft"],
          type: "memory",
        },
        {
          name: "Magniflex Magnifico Virtuoso Elegante",
          handle: "magniflex-magnifico-virtuoso-elegante-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "firm", "medium", "soft"],
          type: "memory",
        },
        {
          name: "Bedgear M3 Performance",
          handle: "beadgear-m3-performance-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["ultraFirm", "firm", "medium", "soft"],
          type: "hybrid",
        },
        {
          name: "Bedgear S7 Performance",
          handle: "beadgear-s7-performance-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "TK"],
          firmness: ["TK", "TK", "TK", "soft"],
          type: "memory",
        },
        {
          name: "Bedgear S5 Performance",
          handle: "bedgear-s5-performance-mattress",
          visible: true,
          hot: true,
          sleepType: ["side", "back"],
          firmness: ["TK", "TK", "medium", "TK"],
          type: "memory",
        },
        {
          name: "Bedgear S3 Performance",
          handle: "beadgear-s3-performance-mattress",
          visible: true,
          hot: true,
          sleepType: ["TK", "back"],
          firmness: ["TK", "firm", "TK", "TK"],
          type: "memory",
        },
      ];
      var variants = [];

      function toStandardizedSize(shopifyOption) {
        var shopifySize = shopifyOption ? shopifyOption.toLowerCase() : "";

        if (shopifySize.includes("twin xl")) {
          // Check Twin XL first
          return sizeTwinXL;
        } else if (shopifySize.includes("twin")) {
          return sizeTwin;
        } else if (shopifySize.includes("full")) {
          return sizeFull;
        } else if (shopifySize.includes("queen")) {
          return sizeQueen;
        } else if (
          shopifySize.includes("king") &&
          shopifySize.includes("split") &&
          shopifySize.includes("cal")
        ) {
          // Check Cal King before King
          return sizeSplitCalKing;
        } else if (
          shopifySize.includes("king") &&
          shopifySize.includes("split")
        ) {
          return sizeSplitKing;
        } else if (shopifySize.includes("king")) {
          return sizeKing;
        } else {
          console.debug("Unable to determine size for ".concat(shopifyOption));
          return "";
        }
      }

      function toStandardizedBrand(shopifyVendor) {
        var brand = shopifyVendor ? shopifyVendor.toLowerCase() : "";

        if (brand.includes("sealy")) {
          return brandSealy;
        } else if (
          brand.includes("tempurpedic") ||
          (brand.includes("tempur") && brand.includes("pedic"))
        ) {
          return brandTempurpedic;
        } else if (brand.includes("stearns") && brand.includes("foster")) {
          return brandStearnsFoster;
        } else if (brand.includes("magniflex")) {
          return brandMagniflex;
        } else if (brand.includes("bedplanet")) {
          return brandBedPlanet;
        } else if (brand.includes("beautyrest")) {
          return brandBeautyRest;
        } else if (brand.includes("bedgear")) {
          return brandBedgear;
        } else {
          console.debug("Unable to determine brand for ".concat(brand));
          return brandNoPreference;
        }
      }

      function filterProducts(renderResults) {
        var _getSelections = getSelections(),
          size = _getSelections.size,
          mattressType = _getSelections.mattressType,
          budget = _getSelections.budget,
          sleepType = _getSelections.sleepType,
          comfortLevel = _getSelections.comfortLevel,
          brand = _getSelections.brand,
          sleepHot = _getSelections.sleepHot; // console.debug('size', size);
        // console.debug('budget', budget);
        // console.debug('sleepType', sleepType);
        // console.debug('comfortLevel', comfortLevel);
        // console.debug('mattressType', mattressType);
        // console.debug('brand', brand);
        // console.debug('sleepHot', sleepHot);
        // console.debug('adjustableBase', adjustableBase);

        var filteredVariants = variants.filter(function (variant) {
          return (
            variant.visible &&
            variant.product.visible &&
            size === variant.standardizedSize &&
            inBudget(variant, budget) &&
            (variant.product.sleepType.includes(sleepType) ||
              sleepType === noPreference) &&
            (variant.product.firmness.includes(comfortLevel) ||
              comfortLevel === noPreference) &&
            (mattressType === variant.product.type ||
              mattressType === noPreference) &&
            (brand === variant.brand || brand === brandNoPreference) &&
            ((sleepHot === yes && variant.product.hot) ||
              (sleepHot === no && !variant.product.sleepHot) ||
              sleepHot === noPreference)
          );
        });

        var priceSort = function priceSort(a, b) {
          return b.price - a.price;
        };

        filteredVariants = filteredVariants.sort(priceSort);
        var results = $("#results");
        var resultsContainer = $("#resultsContainer");
        var noResultsContainer = $("#noResultsContainer"); // hide all

        results.addClass("d-none");
        resultsContainer.addClass("d-none");
        noResultsContainer.addClass("d-none");

        if (renderResults) {
          if (filteredVariants.length > 0) {
            var productCards = $();
            filteredVariants.forEach(function (product, i) {
              // eslint-disable-line no-unused-vars
              productCards = productCards.add(createProductCard(product));
            });
            clearProductResults();
            results.append(
              createResultsHeader().add(
                productCards.wrapAll('<div class="row"></div>').parent(),
              ),
            ); // show product results and form

            results.removeClass("d-none");
            resultsContainer.removeClass("d-none"); // scroll results into view

            $([document.documentElement, document.body]).animate(
              {
                scrollTop: results.offset().top,
              },
              200,
            );
          } else {
            // show no results form
            noResultsContainer.removeClass("d-none");
          }
        }
      }

      function inBudget(variant, budget) {
        var price = Math.floor(variant.price);
        return (
          budget === noPreference || (budget[0] <= price && price <= budget[1])
        );
      }

      function toFormattedBudgetRange(budget) {
        var low = budget[0];
        var high = budget[1];

        if (
          high === Number.POSITIVE_INFINITY ||
          high === Number.POSITIVE_INFINITY.toString()
        ) {
          return "".concat(currencyFormatterNoCents.format(low), " & up");
        } else {
          return ""
            .concat(currencyFormatterNoCents.format(low), " \u2013 ")
            .concat(currencyFormatterNoCents.format(high));
        }
      }

      function updateBudgetOnSizeOrMattressTypeChange() {
        var _getSelections2 = getSelections(),
          size = _getSelections2.size,
          mattressType = _getSelections2.mattressType;

        var newBudget = sizeToBudget.get(
          "".concat(mattressType, "|").concat(size),
        );

        if (newBudget !== currentBudget) {
          var budget1Label = $("label[for=budget1]");
          var budget2Label = $("label[for=budget2]");
          var budget3Label = $("label[for=budget3]");
          budget1Label.text(toFormattedBudgetRange(newBudget[0]));
          budget2Label.text(toFormattedBudgetRange(newBudget[1]));
          budget3Label.text(toFormattedBudgetRange(newBudget[2]));
          var budget1Radio = $("#budget1");
          var budget2Radio = $("#budget2");
          var budget3Radio = $("#budget3");
          budget1Radio.val(
            ""
              .concat(newBudget[0][0].toString(), "-")
              .concat(newBudget[0][1].toString()),
          );
          budget2Radio.val(
            ""
              .concat(newBudget[1][0].toString(), "-")
              .concat(newBudget[1][1].toString()),
          );
          budget3Radio.val(
            ""
              .concat(newBudget[2][0].toString(), "-")
              .concat(newBudget[2][1].toString()),
          );
          budget1Radio.prop("checked", false);
          budget2Radio.prop("checked", false);
          budget3Radio.prop("checked", false);
          currentBudget = newBudget;
        }
      }

      function getSelections() {
        var size = $("#size").val() || sizeSplitKing;
        var mattressType = $("#mattressType").val() || noPreference;
        var selectedBudget =
          $("input[name=budget]:checked").val() || noPreference;
        var budget;

        if (typeof selectedBudget === "string") {
          if (selectedBudget === noPreference) {
            budget = noPreference;
          } else {
            var splitBudget = selectedBudget.split("-");
            budget = [
              parseInt(splitBudget[0]),
              splitBudget[1] === Number.POSITIVE_INFINITY.toString()
                ? Number.POSITIVE_INFINITY
                : parseInt(splitBudget[1]),
            ];
          }
        } else {
          budget = selectedBudget;
        }

        var sleepType =
          $("input[name=sleepType]:checked").val() || noPreference;
        var comfortLevel =
          $("input[name=comfortLevel]:checked").val() || noPreference;
        var brand = $("input[name=brand]:checked").val() || brandNoPreference;
        var sleepHot = $("input[name=sleepHot]:checked").val() || noPreference;
        var adjustableBase =
          $("input[name=adjustableBase]:checked").val() || no;
        return {
          size: size,
          budget: budget,
          sleepType: sleepType,
          comfortLevel: comfortLevel,
          mattressType: mattressType,
          brand: brand,
          sleepHot: sleepHot,
          adjustableBase: adjustableBase,
        };
      }

      function createResultsHeader() {
        var template = [
          '<div class="row">',
          '  <div class="col ml-3 pb-2">',
          "    <h5>Matching Mattresses</h5>",
          "    <p>Based on your preferences we think you'll like the following mattresses.</p>",
          "  </div>",
          "</div>",
        ];
        return $(template.join(""));
      }

      function createProductCard(variant) {
        var financing = "";
        var financeTerm = getFinancing(variant);

        if (financeTerm > 0) {
          financing =
            "0% Interest Only <strong>" +
            currencyFormatterNoCents.format(
              Math.ceil(variant.price / financeTerm),
            ) +
            "</strong>/month";
        }

        var template = [
          '<div class="col-md-4 mb-5 pl-3 pr-3">',
          '  <div class="row">',
          '    <div class="col">', // Comment this line when deployed to BedPlanet
          // '      <a href="https://bedplanet.com' + variant.product.url + '?variant=' + variant.id + '">',
          // Comment this line when running locally or deployed to S3
          '      <a href="' +
            variant.product.url +
            "?variant=" +
            variant.id +
            '">',
          '        <img src="' +
            variant.thumbnail +
            '" class="rounded mx-auto d-block" alt="' +
            variant.product.name +
            '" style="width: 225px; height: 225px;">',
          "      </a>",
          "    </div>",
          "  </div>",
          '  <div class="row">',
          '    <div class="col text-center">',
          "      <strong>" + variant.product.name + "</strong>",
          "    </div>",
          "  </div>",
          '  <div class="row">',
          '    <div class="col text-center">',
          variant.size,
          "    </div>",
          "  </div>",
          '  <div class="row">',
          '    <div class="col text-center">',
          currencyFormatter.format(variant.price),
          financing.length > 0 ? "<br>" : "",
          financing,
          "    </div>",
          "  </div>",
          "</div>",
        ];
        return $(template.join(""));
      } // same as finance_months

      function getFinancing(variant) {
        // eslint-disable-line no-unused-vars
        // const price = chair.price || 0;
        // if (price >= 1999 && price < 8990) {
        //     return 48;
        // } else if (price >= 8990) {
        //     return 60;
        // } else {
        //     return -1;
        // }
        // TODO: for now return false
        return false;
      }

      function clearProductResults() {
        var results = $("#results");
        results.html("");
      }

      function nextStep() {
        var nextStep = $("#wizard").smartWizard("getStepIndex") + 1;

        if (nextStep < steps) {
          $("#wizard").smartWizard("goToStep", nextStep);
        }
      }

      function resetForm() {
        $("#wizard").smartWizard("reset");
        $("#size").prop("selectedIndex", 0);
        $("#mattressType").prop("mattressType", 0);
        $("input[name=budget]").prop("checked", false);
        $("input[name=sleepType]").prop("checked", false);
        $("input[name=comfortLevel]").prop("checked", false);
        $("input[name=brand]").prop("checked", false);
        $("input[name=sleepHot]").prop("checked", false);
        $("input[name=adjustableBase]").prop("checked", false);
        $("#noResultsForm")[0].reset(); // TODO: Clear Bootstrap validation
        // $('#noResultsForm').data('bootstrapValidator').resetForm();
        // $('#noResultsForm').removeClass('was-validated');
      }

      window.resetForm = resetForm;
      /**
       * Accepts either a URL or querystring and returns an object associating
       * each querystring parameter to its value.
       *
       * Returns an empty object if no querystring parameters found.
       */

      function getUrlParams(urlOrQueryString) {
        if ((i = urlOrQueryString.indexOf("?")) >= 0) {
          // eslint-disable-line no-undef
          var queryString = urlOrQueryString.substring(i + 1); // eslint-disable-line no-undef

          if (queryString) {
            return _mapUrlParams(queryString);
          }
        }

        return {};
      }
      /**
       * Helper function for `getUrlParams()`
       * Builds the querystring parameter to value object map.
       *
       * @param queryString {string} - The full querystring, without the leading '?'.
       */

      function _mapUrlParams(queryString) {
        return queryString
          .split("&")
          .map(function (keyValueString) {
            return keyValueString.split("=");
          })
          .reduce(function (urlParams, _ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

            if (Number.isInteger(parseInt(value)) && parseInt(value) == value) {
              urlParams[key] = parseInt(value);
            } else {
              urlParams[key] = decodeURI(value);
            }

            return urlParams;
          }, {});
      }

      $(document).ready(function () {
        // Redirect if contact form has been submitted (i.e. `?form_type=contact`)
        // Any value for this parameter will suffice
        var urlParams = getUrlParams(location.search);

        if (Object.prototype.hasOwnProperty.call(urlParams, "form_type")) {
          window.location = "/pages/thank-you-for-your-submission";
        }

        $("select[name=size]").change(function (e) {
          // eslint-disable-line no-unused-vars
          updateBudgetOnSizeOrMattressTypeChange();
          nextStep();
        });
        $("select[name=mattressType]").change(function (e) {
          // eslint-disable-line no-unused-vars
          updateBudgetOnSizeOrMattressTypeChange();
          nextStep();
        });
        $("input[type=radio][name=budget]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=sleepType]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=comfortLevel]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=brand]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=sleepHot]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=adjustableBase]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        var btnReset = $("<button></button>")
          .text("Start Over")
          .addClass("btn btn-danger")
          .click(function () {
            resetForm();
          }); // Step show event

        $("#wizard").on(
          "showStep",
          function (e, anchorObject, stepNumber, stepDirection, stepPosition) {
            $("#prev-btn").removeClass("disabled");
            $("#next-btn").removeClass("disabled");

            if (stepPosition === "first") {
              $("#prev-btn").addClass("disabled");
            } else if (stepPosition === "last") {
              $("#next-btn").addClass("disabled");
            } else {
              $("#prev-btn").removeClass("disabled");
              $("#next-btn").removeClass("disabled");
            }

            if (stepPosition === "last") {
              // last step
              filterProducts(true);
            } else {
              clearProductResults();
              var results = $("#results");
              var resultsContainer = $("#resultsContainer");
              var noResultsContainer = $("#noResultsContainer"); // hide all

              results.addClass("d-none");
              resultsContainer.addClass("d-none");
              noResultsContainer.addClass("d-none");
            }
          },
        ); // Smart Wizard

        $("#wizard").smartWizard({
          selected: 0,
          enableURLhash: false,
          theme: "arrows",
          // default, arrows, dots, progress
          transition: {
            animation: "fade", // Effect on navigation, none/fade/slide-horizontal/slide-vertical/slide-swing
          },
          toolbarSettings: {
            toolbarPosition: "bottom",
            toolbarExtraButtons: [btnReset],
          },
          autoAdjustHeight: false,
        }); // External Button Events

        $("#reset-btn").click(function () {
          // Reset wizard
          $("#wizard").smartWizard("reset");
          return true;
        });
        $("#prev-btn").click(function () {
          // Navigate previous
          $("#wizard").smartWizard("prev");
          return true;
        });
        $("#next-btn").click(function () {
          // Navigate next
          $("#wizard").smartWizard("next");
          return true;
        });
        $("#resultsForm").submit(function (event) {
          // eslint-disable-line no-unused-vars
          var _getSelections3 = getSelections(),
            size = _getSelections3.size,
            mattressType = _getSelections3.mattressType,
            budget = _getSelections3.budget,
            sleepType = _getSelections3.sleepType,
            comfortLevel = _getSelections3.comfortLevel,
            brand = _getSelections3.brand,
            sleepHot = _getSelections3.sleepHot,
            adjustableBase = _getSelections3.adjustableBase;

          $("#resultsSize").val(size);
          $("#resultsMattressType").val(mattressType);
          $("#resultsBudget").val(budget);
          $("#resultsSleepType").val(sleepType);
          $("#resultsComfortLevel").val(comfortLevel);
          $("#resultsBrand").val(brand);
          $("#resultsSleepHot").val(sleepHot);
          $("#resultsAdjustableBase").val(adjustableBase);
          return true;
        });
        $("#noResultsForm").submit(function (event) {
          // eslint-disable-line no-unused-vars
          var _getSelections4 = getSelections(),
            size = _getSelections4.size,
            mattressType = _getSelections4.mattressType,
            budget = _getSelections4.budget,
            sleepType = _getSelections4.sleepType,
            comfortLevel = _getSelections4.comfortLevel,
            brand = _getSelections4.brand,
            sleepHot = _getSelections4.sleepHot,
            adjustableBase = _getSelections4.adjustableBase;

          $("#noResultsSize").val(size);
          $("#noResultsMattressType").val(mattressType);
          $("#noResultsBudget").val(budget);
          $("#noResultsSleepType").val(sleepType);
          $("#noResultsComfortLevel").val(comfortLevel);
          $("#noResultsBrand").val(brand);
          $("#noResultsSleepHot").val(sleepHot);
          $("#noResultsAdjustableBase").val(adjustableBase);
          return true;
        });
        products.forEach(function (product, index, productArray) {
          // Comment this line when deployed to BedPlanet
          // $.getJSON('https://bedplanet.com/products/' + product.handle + '.js', function(shopifyProduct) {
          // Comment this line when running locally or deployed to S3
          $.getJSON(
            "/products/" + product.handle + ".js",
            function (shopifyProduct) {
              ((productArray[index].name =
                shopifyProduct.title || product.name),
                (productArray[index].price = shopifyProduct.price / 100));
              productArray[index].url = shopifyProduct.url;
              productArray[index].thumbnail = shopifyProduct.featured_image;
              productArray[index].visible = shopifyProduct.available;

              if (
                Object.prototype.hasOwnProperty.call(
                  shopifyProduct,
                  "variants",
                ) &&
                shopifyProduct.variants
              ) {
                shopifyProduct.variants.forEach(
                  function (shopifyVariant, variantIndex) {
                    // eslint-disable-line no-unused-vars
                    var variant = {
                      id: shopifyVariant.id,
                      name: shopifyVariant.name,
                      price: shopifyVariant.price / 100,
                      size: shopifyVariant.option1,
                      standardizedSize: toStandardizedSize(
                        shopifyVariant.option1,
                      ),
                      brand: toStandardizedBrand(shopifyProduct.vendor),
                      thumbnail:
                        Object.prototype.hasOwnProperty.call(
                          shopifyProduct,
                          "featured_image",
                        ) && shopifyVariant.featured_image
                          ? shopifyVariant.featured_image.src
                          : product.thumbnail,
                      sku: shopifyVariant.sku,
                      visible: shopifyVariant.available,
                      product: productArray[index],
                    };
                    variants.push(variant);
                  },
                );
              }
            },
          );
        });
      }); // Restricts input for the set of matched elements to the given inputFilter function.

      (function ($) {
        $.fn.inputFilter = function (inputFilter) {
          return this.on(
            "input keydown keyup mousedown mouseup select contextmenu drop",
            function () {
              if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
              } else if (
                Object.prototype.hasOwnProperty.call(this, "oldValue")
              ) {
                this.value = this.oldValue;
                this.setSelectionRange(
                  this.oldSelectionStart,
                  this.oldSelectionEnd,
                );
              } else {
                this.value = "";
              }
            },
          );
        };
      })(jQuery);

      (function () {
        "use strict";

        window.addEventListener(
          "load",
          function () {
            // Fetch all the forms we want to apply custom Bootstrap validation styles to
            var forms = document.getElementsByClassName("needs-validation"); // Loop over them and prevent submission

            var validation = Array.prototype.filter.call(
              forms,
              function (form) {
                // eslint-disable-line no-unused-vars
                form.addEventListener(
                  "submit",
                  function (event) {
                    if (form.checkValidity() === false) {
                      event.preventDefault();
                      event.stopPropagation();
                    }

                    form.classList.add("was-validated");
                  },
                  false,
                );
              },
            );
          },
          false,
        );
      })();

      /***/
    },
    /******/
  ],
);
